import type { DetailsValues } from './detailsValues';
import { descriptionText } from './detailsView';

/**
 * What's missing (brief §3, right panel): the details a project still lacks
 * before go-live, each with the card that adds it. Pure, in the order the
 * panel lists them. Every project is Draft (decision 2), so all of them count
 * as before go-live.
 */
export type MissingItem = 'contact' | 'description';

export const missingItems = (
  values: Pick<DetailsValues, 'contactId' | 'description'>,
): MissingItem[] => {
  const missing: MissingItem[] = [];
  if (values.contactId === null) missing.push('contact');
  if (descriptionText(values.description) === '') missing.push('description');
  return missing;
};

/** The card each missing item is added in. */
export const MISSING_CARD = {
  contact: 'people',
  description: 'about',
} as const satisfies Record<MissingItem, string>;
